// extracted by mini-css-extract-plugin
export default {"wrapper":"QuestionForm_wrapper__OxUjt","title":"QuestionForm_title__MOOuA","text":"QuestionForm_text__Y0D9C","row":"QuestionForm_row__PZ+GJ"};